import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Our Story', 'Spaces', 'Experience', 'Gallery', 'Contact'];
  return <>
      <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-cream py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-153">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-154">
          {/* Logo */}
          <a href="#" className={`font-serif text-2xl tracking-[0.2em] uppercase transition-colors duration-500 ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-155">
            Copper Crest
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-10" data-id="element-156">
            <div className="flex space-x-8" data-id="element-157">
              {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className={`text-xs tracking-widest uppercase transition-colors duration-300 hover:text-copper ${isScrolled ? 'text-charcoal' : 'text-white/90'}`} data-id="element-158">
                  {link}
                </a>)}
            </div>
            <a href="#contact" className={`px-6 py-3 text-xs tracking-widest uppercase transition-all duration-300 border ${isScrolled ? 'bg-copper text-white border-copper hover:bg-copper-dark hover:border-copper-dark' : 'bg-copper border-copper text-white hover:bg-transparent hover:text-white'}`} data-id="element-159">
              Book a Tour
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className={`md:hidden p-2 transition-colors duration-300 ${isScrolled ? 'text-charcoal' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-160">
            <MenuIcon className="w-6 h-6" data-id="element-161" />
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-162">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-[60] bg-charcoal text-cream flex flex-col" data-id="element-163">
            <div className="p-6 flex justify-end" data-id="element-164">
              <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 text-cream hover:text-copper transition-colors" aria-label="Close menu" data-id="element-165">
                <XIcon className="w-8 h-8" data-id="element-166" />
              </button>
            </div>
            <div className="flex-1 flex flex-col items-center justify-center space-y-8 p-6" data-id="element-167">
              {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} onClick={() => setIsMobileMenuOpen(false)} className="font-serif text-3xl tracking-widest uppercase hover:text-copper transition-colors" data-id="element-168">
                  {link}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="mt-8 px-8 py-4 bg-copper text-white text-sm tracking-widest uppercase hover:bg-copper-dark transition-colors" data-id="element-169">
                Book a Tour
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}